import React from 'react'
import PropTypes from 'prop-types'
import { Paragraph } from '@scentregroup/ui'
import ExternalLink from '../../external-link'
import style from './index.scss'

const MovieProviderBanner = ({ flicksLink }) => {
  const urlIndex = 'https://www.'.length
  const formatFlicksDomain = flicksLink.substring(urlIndex).split('/', 1)
  return (
    <ExternalLink url={flicksLink}>
      <Paragraph className={style.sponsorBlock}>
        Content powered by {formatFlicksDomain}
      </Paragraph>
    </ExternalLink>
  )
}

MovieProviderBanner.propTypes = {
  flicksLink: PropTypes.string,
}

export default MovieProviderBanner
